import { render, staticRenderFns } from "./UserInfoBox.vue?vue&type=template&id=21ab1186&scoped=true&"
import script from "./UserInfoBox.vue?vue&type=script&lang=js&"
export * from "./UserInfoBox.vue?vue&type=script&lang=js&"
import style0 from "./UserInfoBox.vue?vue&type=style&index=0&id=21ab1186&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ab1186",
  null
  
)

export default component.exports